import React, { useRef, useState, useEffect } from 'react';
import styled from 'styled-components';

import {
  useTranslations,
  withTranslations,
} from './../graphql/components/TranslationsProvider';
import { Box, VerticalSpacing } from '../components/Boneyard';
import Markdown from '../components/Markdown';
import PLANE_ICON_LEFT from '../images/pattern-plane-path-top-left.svg';
import PLANE_ICON_RIGHT from '../images/pattern-plane-path-top-right.svg';
import ERROR_BOUNDARY_TRANSLATIONS_QUERY from './errorBoundary/errorBoundaryTranslations.query.graphql';
import { EXPIRED_TRANSACTION_ID_PAGE } from '../../automationHooks';

const ErrorBox = styled(Box)`
  text-align: center;
  margin: 0 auto;
  margin-top: 150px;
  min-height: 10em;
  line-height: 1.8;
`;

const RightImg = styled.img`
  float: right;
  margin-bottom: 25px;
`;

const LeftImg = styled.img`
  float: left;
`;

// https://overreacted.io/making-setinterval-declarative-with-react-hooks/
function useInterval(callback, delay) {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

const ExpiredTransactionIdErrorPage = () => {
  const [timeToRedirect, setTimeToRedirect] = useState(30);
  const {
    errors: { expiredTransactionIdMessage },
  } = useTranslations();

  useInterval(() => {
    if (timeToRedirect === 1) {
      return;
    }
    setTimeToRedirect(timeToRedirect - 1);
  }, 1000);

  useEffect(() => {
    if (timeToRedirect === 1) {
      window.location.href = '/';
    }
  }, [timeToRedirect]);

  return (
    <>
      <div data-hook={EXPIRED_TRANSACTION_ID_PAGE.hook}>
        <ErrorBox data-hook={EXPIRED_TRANSACTION_ID_PAGE.hook}>
          <VerticalSpacing size={4} />
          <Markdown
            source={expiredTransactionIdMessage}
            data={{ timeToRedirect }}
          />
          <VerticalSpacing size={10} />
        </ErrorBox>
        <RightImg src={PLANE_ICON_RIGHT} />
        <LeftImg src={PLANE_ICON_LEFT} />
      </div>
    </>
  );
};

export default withTranslations(
  ERROR_BOUNDARY_TRANSLATIONS_QUERY,
  ExpiredTransactionIdErrorPage
);
